var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBicycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 675",
    style: {
      enableBackground: "new 0 0 1280 675"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M888.4,422.1c-4.4,70.9,8.9,152.2-88.7,149.3c22.2-25.1,29.6-31,20.7-65c-19.2-79.8-122.7,5.9-164,14.8 c-41.4,8.9-165.5,7.4-192.1,1.5c-53.2-11.8-51.7-96.1,10.3-104.9s189.2-5.9,218.7,0c29.6,5.9,39.9,34,82.8,35.5 c164,7.4,159.6-246.8-5.9-232s-57.6,32.5-76.8,35.5c-19.2,3-99,3-118.2,0c-51.7-7.4-63.5-81.3-13.3-100.5 c50.2-19.2,60.6-8.9,82.8-4.4c41.4,7.4,150.7,97.5,170,17.7v-60.6c88.7,14.8,60.6,73.9,72.4,141.9l174.4,5.9 c22.2,4.4,22.2,22.2,20.7,41.4c36.9,5.9,164-13.3,184.7,14.8c20.7,28.1,7.4,50.2-11.8,59.1c-32.5,14.8-122.7-4.4-162.6,4.4 c-16.3,5.9,0,47.3-42.9,47.3h-164L888.4,422.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.3,234.5c5.9-19.2,106.4-16.3,127.1-20.7c23.6,35.5,59.1,36.9,63.5,85.7c4.4,48.8,3,76.8-3,99 c-5.9,22.2-41.4,59.1-60.6,63.5c-19.2,4.4-104.9-4.4-127.1-19.2V234.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.6,111.8c7.4,23.6-45.8,62.1-45.8,73.9c17.7,39.9,72.4,59.1,69.5,109.4l303,11.8v53.2l-303,11.8 c19.2,50.2-62.1,90.1-68,118.2c-5.9,28.1,63.5,50.2,35.5,76.8s-34,5.9-45.8-17.7c-41.4-76.8-11.8-72.4,29.6-124.1 s16.3-85.7,20.7-138.9c-13.3-35.5-70.9-60.6-70.9-100.5s26.6-72.4,38.4-81.3l38.4,5.9L341.6,111.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.1,482.7c23.6,0,47.3,41.4,32.5,62.1c-81.3,38.4-165.5,88.7-252.7,109.4c-20.7,1.5-54.7,0-73.9,0 s-195.1,5.9-138.9-76.8c69.5-10.3,162.6,10.3,229.1-3C635.7,561.1,711.1,496,773.1,482.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.1,24.6c26.6-5.9,212.8-5.9,240.9,0c28.1,5.9,190.6,82.8,208.4,94.6c17.7,11.8,20.7,35.5,4.4,56.2 c-16.3,20.7-41.4,7.4-63.5-1.5c-42.9-17.7-128.6-69.5-167-76.8c-66.5-13.3-165.5,7.4-235-1.5c-22.2-17.7-19.2-62.1,11.8-69.5 L340.1,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.6,238.9c133-13.3,140.4,193.6,10.3,193.6C663.8,432.5,656.4,250.7,774.6,238.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.7,296.5v76.8C66.7,373.4-2.7,386.7,3.2,329s69.5-31,100.5-34V296.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycle);
export default __webpack_public_path__ + "static/media/bicycle.5ff8dd24bc4b276a302efb05c4ca86e1.svg";
export { ForwardRef as ReactComponent };